// src/cropUtils.js

/**
 * Loads an image from a data URL or URL string.
 */
function createImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous'); 
    img.onload = () => resolve(img);
    img.onerror = error => reject(error);
    img.src = url;
  });
}

/**
 * Given an image source and pixelCrop (from react-easy-crop),
 * returns a data URL of the cropped area.
 */
export async function getCroppedImg(imageSrc, pixelCrop) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext('2d');

  // draw the cropped area onto our canvas
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  // return a data URL
  return canvas.toDataURL('image/png');
}
